"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.styles = styles_1.createStyles({
    popper: {},
    popperCard: {
        maxWidth: 600,
        border: 'none',
        '& > ul': {
            listStyleType: 'none',
            margin: 0,
            padding: 0,
        },
    },
    listItem: {
        borderRadius: 5,
    },
    field: {},
});
